import * as React from 'react';

import { getFormattedElementsArray } from './prompt';

import { Prompt } from '../../index';
import { ReadAloudButton } from '../readAloud/readAloudButton';
import { useReadAloud } from '../readAloud/readAloudContext';
import { useFirstLineStyle, useReadAloudSection } from '../readAloud/readAloudSection';
import { SPOKEN_WORD_ATTRIBUTE, promptToSpeechText } from '../../libs/speech/speechText';
import { BLANK_WORD } from '../../libs/speech/wordCollector';

const markBlanks = (promptElements: React.ReactElement[]) => promptElements.map(element => (
  typeof element.props.children === 'string' ? element : React.cloneElement(element, { [SPOKEN_WORD_ATTRIBUTE]: BLANK_WORD, })
));

const SpokenPrompt = ({ prompt, promptElements, }) => {
  const content = React.useMemo(() => <div className="fill-in-blank-prompt-container">{getFormattedElementsArray(markBlanks(promptElements))}</div>, [promptElements]);
  const { contentId, readAloudButtonProps, rendered, } = useReadAloudSection({ content, speechText: promptToSpeechText(prompt), });
  const contentRef = React.useRef<HTMLDivElement>(null);
  const firstLineStyle = useFirstLineStyle(contentRef, rendered);

  return (
    <div className="prompt-and-read-aloud fill-in-blank-prompt-and-read-aloud" style={firstLineStyle}>
      <div id={contentId} ref={contentRef}>{rendered}</div>
      <ReadAloudButton label="Read the sentence aloud" {...readAloudButtonProps} />
    </div>
  );
};

const FillInBlankPromptWithReadAloud = ({ prompt, promptElements, }) => {
  const { readAloudEnabled, } = useReadAloud();
  if (!readAloudEnabled || !promptElements) { return <Prompt className="fill-in-blank-prompt-container" elements={promptElements} />; }

  return <SpokenPrompt prompt={prompt} promptElements={promptElements} />;
};

export { FillInBlankPromptWithReadAloud };
